/* ==========================================================================
   BELORA — SKIMS PURE · size listbox (snippets/sk-size-listbox.liquid)

   Measured on the reference's rail cards (vf-sk-lb-states-1440.json): the
   button opens the list and focus moves INTO the list, which tracks an active
   row by aria-activedescendant; arrows move it and skip disabled rows (no
   wrap); Home/End jump; Enter or Space picks and closes; Escape closes; focus
   goes back to the button either way. Pointer: hovering a row makes it active,
   clicking an enabled row picks it, clicking outside closes.

   Picking writes the variant id into the form's hidden `id` and enables the
   card's add button. The add is the form's own submit, so it stays Prestige's
   <product-form> — no second cart path.

   Delegated on document so the bag's cards, which Prestige re-renders on
   every cart change, never need rebinding. Loaded from two places (the bag
   and the product rail), so it guards against running twice.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__skListbox) return;
  window.__skListbox = true;

  var openRoot = null;

  function parts(root) {
    return {
      btn: root.querySelector('[data-sk-lb-btn]'),
      list: root.querySelector('[data-sk-lb-list]'),
      value: root.querySelector('[data-sk-lb-value]'),
      input: root.querySelector('[data-sk-lb-input]'),
    };
  }
  function options(list) { return Array.prototype.slice.call(list.querySelectorAll('[role="option"]')); }
  function enabled(o) { return o.getAttribute('aria-disabled') !== 'true'; }

  function setActive(root, opt) {
    var p = parts(root);
    options(p.list).forEach(function (o) { o.classList.toggle('is-active', o === opt); });
    if (opt) {
      p.list.setAttribute('aria-activedescendant', opt.id);
      // keep the active row inside the 160px window
      var top = opt.offsetTop, bottom = top + opt.offsetHeight;
      if (top < p.list.scrollTop) p.list.scrollTop = top;
      else if (bottom > p.list.scrollTop + p.list.clientHeight) p.list.scrollTop = bottom - p.list.clientHeight;
    } else {
      p.list.removeAttribute('aria-activedescendant');
    }
  }

  /* The list opens downward, as measured. Inside a horizontal scroller (the
     bag's rail, the look rail below 1024) the scroller would clip it — native
     horizontal scrolling forces vertical clipping — so there, and only there,
     it opens upward over the card instead. */
  function place(root) {
    var p = parts(root);
    root.classList.remove('sk-lb--up');
    var r = p.list.getBoundingClientRect();
    var el = root.parentElement;
    while (el && el !== document.body) {
      var cs = getComputedStyle(el);
      if (/(auto|scroll|hidden)/.test(cs.overflowY) || /(auto|scroll|hidden)/.test(cs.overflowX)) {
        var c = el.getBoundingClientRect();
        if (r.bottom > c.bottom + 1) { root.classList.add('sk-lb--up'); }
        return;
      }
      el = el.parentElement;
    }
    if (r.bottom > window.innerHeight && p.btn.getBoundingClientRect().top > r.height + 8) root.classList.add('sk-lb--up');
  }

  function open(root) {
    if (openRoot && openRoot !== root) close(openRoot, false);
    var p = parts(root);
    if (!p.btn || !p.list) return;
    p.list.hidden = false;
    p.btn.setAttribute('aria-expanded', 'true');
    root.classList.add('is-open');
    place(root);
    var opts = options(p.list);
    var sel = opts.filter(function (o) { return o.getAttribute('aria-selected') === 'true'; })[0];
    setActive(root, sel || null);
    p.list.focus({ preventScroll: true });
    openRoot = root;
  }

  function close(root, returnFocus) {
    var p = parts(root);
    if (!p.list || p.list.hidden) return;
    p.list.hidden = true;
    p.btn.setAttribute('aria-expanded', 'false');
    root.classList.remove('is-open', 'sk-lb--up');
    setActive(root, null);
    if (openRoot === root) openRoot = null;
    if (returnFocus) p.btn.focus({ preventScroll: true });
  }

  function choose(root, opt) {
    if (!opt || !enabled(opt)) return;
    var p = parts(root);
    options(p.list).forEach(function (o) { o.setAttribute('aria-selected', o === opt ? 'true' : 'false'); });
    if (p.value) { p.value.textContent = opt.getAttribute('data-label') || opt.textContent.trim(); p.value.classList.add('is-chosen'); }
    if (p.input) { p.input.value = opt.getAttribute('data-value'); p.input.disabled = false; }
    var form = root.closest('form');
    var add = form && form.querySelector('[data-sk-lb-add]');
    if (add) add.disabled = false;
  }

  function move(root, dir) {
    var p = parts(root);
    var opts = options(p.list).filter(enabled);
    if (!opts.length) return;
    var cur = p.list.querySelector('.is-active');
    var i = opts.indexOf(cur);
    var next;
    if (dir === 'first') next = opts[0];
    else if (dir === 'last') next = opts[opts.length - 1];
    else if (i < 0) next = dir > 0 ? opts[0] : opts[opts.length - 1];
    else next = opts[Math.max(0, Math.min(opts.length - 1, i + dir))];
    setActive(root, next);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sk-lb-btn]');
    if (btn) {
      var root = btn.closest('[data-sk-lb]');
      if (root.classList.contains('is-open')) close(root, true); else open(root);
      return;
    }
    var opt = e.target.closest && e.target.closest('[data-sk-lb-list] [role="option"]');
    if (opt) {
      var r = opt.closest('[data-sk-lb]');
      if (!enabled(opt)) return;                 // a disabled row does nothing, the list stays open
      choose(r, opt);
      close(r, true);
      return;
    }
    if (openRoot && !openRoot.contains(e.target)) close(openRoot, false);
  });

  document.addEventListener('mousemove', function (e) {
    if (!openRoot) return;
    var opt = e.target.closest && e.target.closest('[data-sk-lb-list] [role="option"]');
    if (opt && openRoot.contains(opt) && enabled(opt) && !opt.classList.contains('is-active')) setActive(openRoot, opt);
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-sk-lb-btn]')) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var root = t.closest('[data-sk-lb]');
        open(root);
        if (!root.querySelector('.is-active')) move(root, e.key === 'ArrowDown' ? 'first' : 'last');
      }
      return;                                    // Enter / Space arrive as a click
    }
    if (!(t.matches && t.matches('[data-sk-lb-list]'))) return;
    var r = t.closest('[data-sk-lb]');
    switch (e.key) {
      case 'ArrowDown': e.preventDefault(); move(r, 1); break;
      case 'ArrowUp': e.preventDefault(); move(r, -1); break;
      case 'Home': case 'PageUp': e.preventDefault(); move(r, 'first'); break;
      case 'End': case 'PageDown': e.preventDefault(); move(r, 'last'); break;
      case 'Enter': case ' ':
        e.preventDefault();
        var a = t.querySelector('.is-active');
        if (a) choose(r, a);
        close(r, true);
        break;
      case 'Escape':
        e.preventDefault();
        e.stopPropagation();                     // the bag's Escape must not close the drawer too
        close(r, true);
        break;
      case 'Tab': close(r, false); break;
    }
  }, true);

  window.addEventListener('resize', function () { if (openRoot) close(openRoot, false); });
})();
